<h2 mat-dialog-title>{{'VALIDATION' | translate}} {{'ERRORS' | translate}}</h2>
<mat-dialog-content class="mat-typography">

  @if (validationModel?.errors?.length !== 0) {
    @if (rawErrors.length > 0) {
      <div class="mb-3">
        @for (msg of rawErrors; track msg) {
          <div class="alert alert-danger mb-2">
            <span class="fa-light fa-triangle-exclamation mr-1" style="vertical-align: middle"></span>
            {{ msg | translate }}
          </div>
        }
      </div>
    }
    @for (group of validationErrorGroups | keyvalue; track group) {
      <mat-list dense="true">
        <div class="mb-2 mr-2 validation-error-title">
          <span class="fa-light fa-triangle-exclamation text-danger mr-1 pb-1"
          style="vertical-align: middle"></span>
          <h3 class="text-truncate d-inline">{{validationErrorsTranslationMap.get(group.key)| translate}}</h3>
        </div>
        @if (group.key === validationError.ActivationsForDeviceMissing) {
          <div class="border-bottom mb-2">
            <h4 class="mb-2 mr-2 text-danger text-truncate">{{'DEVICES'| translate}}:</h4>
            @for (error of group.value; track error) {
              <mat-list-item class="text-truncate">
                <span [ngClass]="error.deviceType | deviceIconClass" class="mr-1"
                style="vertical-align: middle"></span>
                @if (error.deviceName) {
                  <span>{{ error.deviceName }} </span>
                }
                @if (!error.deviceName) {
                  <span>{{ error.deviceId }} </span>
                }
                <span>&nbsp;({{ error.deviceType | deviceType }})</span>
              </mat-list-item>
            }
          </div>
        }
        @if (group.key === validationError.ConlictingRoutersFound) {
          <div class="border-bottom mb-2">
            <h4 class="mb-2 mr-2 text-danger text-truncate">{{ 'CONFLICTS'| translate }}:</h4>
            @for (conflict of group.value; track conflict) {
              <mat-list-item class="text-truncate">
                <span [ngClass]="(conflict.deviceId | findDeviceType : deviceMap) | deviceIconClass" class="mr-1" style="vertical-align: middle"></span>
                @if (conflict.deviceId | findDeviceName: deviceMap) {
                  <span>{{ conflict.deviceId | findDeviceName: deviceMap }}</span>
                }
                @if (!conflict.deviceId | findDeviceName: deviceMap) {
                  <span>{{ conflict.deviceId }}</span>
                }
                <span>&nbsp;({{ (conflict.deviceId | findDeviceType: deviceMap) | deviceType }})</span>
                <span>&nbsp;{{ 'IN_ROUTING' | translate }}</span>
                <span (click)="openRoutePage(conflict.routerId)"class="router-name cursorPointer">&nbsp;{{conflict.routerName}}</span>
                <span>
                  ({{ daysMap.get(conflict.day) | translate }} {{ trimTime(conflict.startTime.toString()) }} - {{ trimTime(conflict.endTime.toString()) }})
                </span>
              </mat-list-item>
            }
          </div>
        }
      </mat-list>
    }
  }


</mat-dialog-content>

<mat-dialog-actions class="mt-5">
  <!--    Send "true" as indicator that route needs to be saved as incomplete-->
  <span class="btn btn-outline-danger mr-2 cursorPointerHover" (click)="this.dialogRef.close(true)"><span
  class="fa-light fa-floppy-disk"></span> {{'SAVE_AS_INCOMPLETE' |translate}}</span>
  <span class="btn btn-outline-primary cursorPointerHover" (click)="this.dialogRef.close()"><span
  class="fa-light fa-xmark"></span> {{'CANCEL' |translate}}</span>


</mat-dialog-actions>
